import axios from 'axios';

import authServiceFactory from 'src/services/authServiceFactory';

import { downloadFileWithFilename } from './downloadFileWithFilename';

export const downloadFile = async (
  downloadUrl: string,
  handleDownload: () => void,
  handleError?: (error: any) => void,
) => {
  try {
    const token = await authServiceFactory().getToken();

    const response = await axios({
      url: downloadUrl,
      method: 'GET',
      responseType: 'blob',
      headers: {
        ...(token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {}),
      },
    });
    downloadFileWithFilename(response);
    handleDownload();
  } catch (error) {
    if (handleError) {
      handleError(error);
    } else {
      throw error;
    }
  }
};
